module.exports = __webpack_public_path__ + "static/img/404.71018898.png";